import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import { CardSection } from 'legacyComponents/layout/cardSection';
import { ThreadCard } from 'legacyComponents/cards/types/thread';

import { MainWrapper } from 'legacyComponents/styled/lib';

const ProfileThreads = props => {
  const { appManager } = props;
  const { profile, threadsConn } = appManager;
  const threads = threadsConn.arrayApp;

  const { canUpdate, fullName } = profile;
  const displayName = fullName.split(' ')[0];

  return (
    <MainWrapper>
      <CardSection
        title='Threads'
        subTitle={' '}
        owner={canUpdate}
        ownerName={displayName}
        cardApp={threads}
        CardComponent={ThreadCard}
        noDataCardType='forumThreads'
        canShowNoDataCard
      />
    </MainWrapper>
  );
};

ProfileThreads.propTypes = {
  routeName: PropTypes.string,
  params: PropTypes.object,
  t: PropTypes.func,
  appManager: PropTypes.object,
};

export default withNamespaces()(observer(ProfileThreads));
